import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { user, signOut } = useAuth();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-card/90 backdrop-blur-xl border-b border-border shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="text-xl md:text-2xl font-semibold tracking-tight text-foreground">
          Oli
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          <Link to="/shop" className="text-sm font-medium text-foreground/80 hover:text-foreground transition-colors">
            Shop
          </Link>
          <Link to="/about" className="text-sm font-medium text-foreground/80 hover:text-foreground transition-colors">
            About
          </Link>
          <Link to="/journal" className="text-sm font-medium text-foreground/80 hover:text-foreground transition-colors">
            Journal
          </Link>
          {user ? (
            <div className="flex items-center gap-4">
              <Link to="/orders" className="text-sm font-medium text-foreground/80 hover:text-foreground transition-colors">
                Orders
              </Link>
              <button
                onClick={() => signOut()}
                className="text-sm font-medium text-foreground/80 hover:text-foreground transition-colors"
              >
                Sign out
              </button>
            </div>
          ) : (
            <Link to="/login" className="text-sm font-medium text-foreground/80 hover:text-foreground transition-colors">
              Sign in
            </Link>
          )}
          <Link
            to="/shop"
            className="bg-primary text-primary-foreground text-sm font-medium px-6 py-2.5 rounded-full hover:opacity-90 transition-opacity"
          >
            Join waitlist
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden flex flex-col gap-1.5 p-2"
          aria-label="Menu"
        >
          <span className={`block w-5 h-0.5 bg-foreground transition-transform ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-5 h-0.5 bg-foreground transition-opacity ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block w-5 h-0.5 bg-foreground transition-transform ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-card/95 backdrop-blur-xl border-t border-border px-6 py-6 space-y-4 animate-fade-in">
          <Link to="/shop" className="block text-foreground text-lg font-medium">Shop</Link>
          <Link to="/about" className="block text-foreground text-lg font-medium">About</Link>
          <Link to="/journal" className="block text-foreground text-lg font-medium">Journal</Link>
          {user ? (
            <>
              <Link to="/orders" className="block text-foreground text-lg font-medium">Orders</Link>
              <button onClick={() => signOut()} className="block text-foreground/70 text-lg font-medium">
                Sign out
              </button>
            </>
          ) : (
            <Link to="/login" className="block text-foreground text-lg font-medium">Sign in</Link>
          )}
          <Link to="/shop" className="inline-block bg-primary text-primary-foreground text-sm font-medium px-6 py-2.5 rounded-full">
            Join waitlist
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;
